import { collection, doc, getDocs, query, where, addDoc, updateDoc, deleteDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Supplier, SupplierFormData, PerplexitySupplierInfo } from '../types/supplier';
import { perplexityService } from './perplexityService';

const SUPPLIERS_COLLECTION = 'suppliers';

export const getSuppliers = async (organizationId: string): Promise<Supplier[]> => {
  try {
    const q = query(
      collection(db, SUPPLIERS_COLLECTION),
      where('organizationId', '==', organizationId)
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as Supplier[];
  } catch (error) {
    console.error('Error fetching suppliers:', error);
    throw error;
  }
};

export const getSupplier = async (supplierId: string): Promise<Supplier | null> => {
  try {
    const docRef = doc(db, SUPPLIERS_COLLECTION, supplierId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
      } as Supplier;
    }
    return null;
  } catch (error) {
    console.error('Error fetching supplier:', error);
    throw error;
  }
};

export const createSupplier = async (
  organizationId: string,
  supplierData: SupplierFormData
): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, SUPPLIERS_COLLECTION), {
      ...supplierData,
      organizationId,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return docRef.id;
  } catch (error) {
    console.error('Error creating supplier:', error);
    throw error;
  }
};

export const updateSupplier = async (
  supplierId: string,
  supplierData: Partial<SupplierFormData>
): Promise<void> => {
  try {
    const docRef = doc(db, SUPPLIERS_COLLECTION, supplierId);
    await updateDoc(docRef, {
      ...supplierData,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error('Error updating supplier:', error);
    throw error;
  }
};

export const deleteSupplier = async (supplierId: string): Promise<void> => {
  try {
    const docRef = doc(db, SUPPLIERS_COLLECTION, supplierId);
    await deleteDoc(docRef);
  } catch (error) {
    console.error('Error deleting supplier:', error);
    throw error;
  }
};

export const fetchSupplierInfo = async (
  name: string,
  location: string
): Promise<PerplexitySupplierInfo> => {
  return perplexityService.searchSupplier(name, location);
};
